import { render, staticRenderFns } from "./zgy-crumb.vue?vue&type=template&id=5f97a501&scoped=true&"
import script from "./zgy-crumb.vue?vue&type=script&lang=js&"
export * from "./zgy-crumb.vue?vue&type=script&lang=js&"
import style0 from "./zgy-crumb.vue?vue&type=style&index=0&id=5f97a501&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f97a501",
  null
  
)

export default component.exports